import { ProjectCategoryModel } from './../../model/CronosModel';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, ToastController } from 'ionic-angular';
import { CronosService } from './../../services/CronosService';

@IonicPage()
@Component({
  selector: 'page-cronos-category-form',
  templateUrl: 'cronos-category-form.html',
})
export class CronosCategoryFormPage {

  public boardId: number;
  public clientId: number;
  public edit: boolean;
  public model: ProjectCategoryModel;
  public formTouched: boolean;
  public formValid: boolean;
  public formErrors: Array<number>;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public viewCtrl: ViewController,
    private toastCtrl: ToastController,
    private cronosService: CronosService
  ) {
    if (this.navParams.get('boardId')) {
      this.boardId = this.navParams.get('boardId');
    }
    if (this.navParams.get('clientId')) {
      this.clientId = this.navParams.get('clientId');
    }
    if (this.navParams.get('category')) {
      this.edit = true;
      this.model = this.navParams.get('category');
    } else {
      this.model = {
        boardId: this.boardId,
        clientId: this.clientId,
        color: null,
        id: null,
        name: null
      }
      this.edit = false;
    }
    this.formTouched = false;
    this.formValid = true;
    this.formErrors = [];
  }

  cancel() {
    this.viewCtrl.dismiss();
  }

  confirm() {
    this.formTouched = true;
    this.formValid = true;
    this.formErrors = [];
    if (this.model.name == null || this.model.name == '') {
      this.formValid = false;
      this.formErrors.push(1);
    }
    if (this.model.color == null || this.model.color == '') {
      this.formValid = false;
      this.formErrors.push(2);
    }
    if (this.formValid) {
      this.cronosService.saveCategory(this.model).subscribe(
        data => {
          this.presentToast('Categoria gravada com sucesso');
          this.viewCtrl.dismiss();
        },
        err => {
          this.presentToast('Houve um erro ao salvar a Categoria');
        }
      );
    }
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });  
    toast.present();
  }

  isColor(hexColor: string, r: number, g: number, b: number) {
    if (hexColor != null && hexColor != undefined) {
      const convertedRgbColor = this.hexToRgb(hexColor);
      if (convertedRgbColor != null) {
        return r == convertedRgbColor.r && g == convertedRgbColor.g && b == convertedRgbColor.b;
      }
    }
    return false;
  }

  selectColor(r: number, g: number, b: number) {
    this.model.color = this.rgbToHex(r, g, b);
  }

  hexToRgb(hex) {
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
  }

  componentToHex(c) {
    const hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  rgbToHex(r, g, b) {
    return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
  }

  isValid(item: number): boolean {
    return this.formTouched == false || (this.formValid == false && this.formErrors.find(x => x == item) == null);
  }

}



// WEBPACK FOOTER //
// ./src/pages/cronos-category-form/cronos-category-form.ts